import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import DetailDeFacturationComponent from '../../../components/Mouvement/Panel/DetailDeFacturationComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class DetailDeFacturationPanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.DETAIL_DE_FACTURATION;
    this.defaultSize = 6;
    this.icon = { name: 'th list' };
  }

  getLibelle = () => 'Détail de facturation';

  isEmpty = (data: Mouvement) => !data?.lignes?.find(
    (ligne) => ligne?.lfacMtbase || ligne?.lfacLibelle || ligne?.lfacMtremise
      || ligne?.lfacMtunitaire || ligne?.lfacQuantite || ligne?.lfacUnite1 || ligne?.lfacDate || ligne?.lfacDatefin,
  );

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <DetailDeFacturationComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default DetailDeFacturationPanel;
